import api from '../../services/api';

export const fetchAssetsLocationDetailsService = async () => {
    try {
        return await api
            .get(`/AssetData/GetAssetsLocationDetails`, {
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(function (response: any) {
                if (response) {
                    return response.data;
                }
            });
    } catch (error) {
        console.error('Error fetching initial state:', error);
        return [];
    }
};